// Module
var code = "<div class=\"spim\"> <input type=\"text\" class=\"form-control\" data-bind=\"inputMask: { type: 'Decimal', decimalSize: 2, value: DisplayValue}, textInput: DisplayValue\" data-with-number-group-separators=\"true\"/> </div>";
// Exports
export default code;